import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData } from '../Services/api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import Pagination from '../Services/Pagination'

const FAQList = () => {
    const [faqList, setFaqList] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const fetchFAQs = async (pageNumber = 1) => {
        try {
            const res = await getData(`/faqs/list?page=${pageNumber}`);
            if (res.status) {
                setFaqList(res.data || []);
                setPage(res.pagination.currentPage);
                setPages(res.pagination.totalPages);
                setTotal(res.pagination.totalRecords);
            }
        } catch (error) {
            console.log("error fetch faqs", error)
        }
    }

    useEffect(() => {
        fetchFAQs(page);
    }, [page]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchFAQs(pageNumber);
        }
    };
    const handleDelete = (slug) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/cms/delete/${slug}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchFAQs();
                    }
                } catch (error) {
                    console.log("error delete cms page", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/faqs/faq-list">FAQ</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            FAQs List
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">FAQs List</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="text-end pb-sm-2 p-4">
                                        <Link
                                            to="/faqs/add-faq"
                                            className="btn btn-primary d-inline-flex align-item-center"
                                        >
                                            <i className="fas fa-plus f-18 me-2" /> Add FAQs
                                        </Link>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Questions</th>
                                                    <th>Answers</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    faqList?.length > 0 ? (
                                                        faqList?.map((faq, index) => {
                                                            return (
                                                                <tr key={faq._id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{faq.question}</h6>
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            className="truncate"
                                                                            dangerouslySetInnerHTML={{ __html: faq.answer }}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/faqs/view-faq/${faq._id}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/faqs/update-faq/${faq._id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <a
                                                                                    onClick={() => handleDelete(faq.id)}
                                                                                    className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className='text-center'>No FAQs Found</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                            page={page}
                                            pages={pages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQList